/* eslint-disable react-hooks/exhaustive-deps */
import { API_URL_PAY } from "../../config";
import { useCallback, useEffect, useState } from "react";
import api from "../../config/api";
import { FaSpinner } from "react-icons/fa";

const JumSIM = ({ id, startDate, endDate, trigger }) => {
  const [all, setAll] = useState(0);

  const [loading, setLoading] = useState({
    all: false,
  });

  useEffect(() => {
    if (trigger > 1) {
      loadDataTotalAll();
    }
  }, [id, startDate, endDate, trigger]);


  const loadDataTotalAll = useCallback(async () => {
    setLoading((prev) => ({ ...prev, all: true }));
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?jmlSim=3&periode=5&outletId=${id}&date_first=${startDate}&date_second=${endDate}`
      );
      setAll(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading((prev) => ({ ...prev, all: false }));
    }
  }, [id, startDate, endDate]);

  return (
    <>
      <div className="col-span-1 flex-col flex text-center border-black">
        {loading.all ? (
          <div className="flex justify-center items-center h-full">
            <FaSpinner className="animate-spin text-gray-500 text-xl" />
          </div>
        ) : (
          <span className="font-bold text-[10px] md:text-[20px]">
            {all ? all.total : [0]}
          </span>
        )}
      </div>
    </>
  );
};

export default JumSIM;
